import { DATE_FORMAT } from 'common/constants/constants';
import {
  StyledFilterSetDueDate,
  StyledFilterSetHeader,
  StyledFilterSetOptions,
  StyledSeparator
} from './FilterSetHeader.style';
import moment from 'moment';
import useSelectedFilterSet from '../../../../../hooks/useSelectedFilterSet';
import SaveFiltersButton from './SaveFiltersButton';
import NavigationMenu from './NavigationMenu/NavigationMenu';
import EditFilterSetButton from './EditFilterSetButton';
import useIsFilterSetOwner from '../../../FilterSet/useIsFilterSetOwner';
import FilterSetTitle from './FilterSetTitle';
import ClearFiltersButton from './ClearFiltersButton';

const FilterSetHeader = ({ Context, isCollapsed, toggleCollapse }) => {
  const filterSet = useSelectedFilterSet(Context);
  const isOwner = useIsFilterSetOwner(filterSet);
  const dueDate = filterSet?.metadata?.due_date;

  return (
    <StyledFilterSetHeader>
      <FilterSetTitle
        filterSet={filterSet}
        isCollapsed={isCollapsed}
        toggleCollapse={toggleCollapse}
      />

      {dueDate && (
        <>
          <StyledSeparator />
          <StyledFilterSetDueDate>
            TARGET: {moment(dueDate).format(DATE_FORMAT)}
          </StyledFilterSetDueDate>
        </>
      )}

      <StyledSeparator />
      <StyledFilterSetOptions onClick={e => e.stopPropagation()}>
        <NavigationMenu Context={Context} />
        {isOwner && <EditFilterSetButton Context={Context} />}
        <ClearFiltersButton Context={Context} />
      </StyledFilterSetOptions>

      {!isCollapsed && isOwner && <SaveFiltersButton Context={Context} />}
    </StyledFilterSetHeader>
  );
};

export default FilterSetHeader;
